import React, { useState, useEffect } from 'react';
import './InterventoriaPage.css';

const InterventoriaPage = ({ onVolver, reporteParaEditar }) => {
  const [titulo, setTitulo] = useState('');
  const [resumen, setResumen] = useState('');
  const [cifraLongitud, setCifraLongitud] = useState('');
  const [cifraInversion, setCifraInversion] = useState('');
  const [cifraDuracion, setCifraDuracion] = useState('');
  const [cifraTpd, setCifraTpd] = useState('');
  const [descParrafo1, setDescParrafo1] = useState('');
  const [descParrafo2, setDescParrafo2] = useState('');
  const [descParrafo3, setDescParrafo3] = useState('');
  const [descParrafo4, setDescParrafo4] = useState('');
  const [compromisos, setCompromisos] = useState('');

  const [imagenPrincipal, setImagenPrincipal] = useState(null);
  const [imagenParrafo3, setImagenParrafo3] = useState(null);
  const [imagenParrafo4, setImagenParrafo4] = useState(null);
  const [imagenesTemaInteres, setImagenesTemaInteres] = useState([]);
  const [imagenesGaleria, setImagenesGaleria] = useState([]);

  const [existingImagenP3Url, setExistingImagenP3Url] = useState(null);
  const [existingImagenP4Url, setExistingImagenP4Url] = useState(null);
  const [existingTemaInteres, setExistingTemaInteres] = useState([]);
  const [existingGaleria, setExistingGaleria] = useState([]);

  const [urlsAEliminar, setUrlsAEliminar] = useState([]);

  const [previewsTemaInteres, setPreviewsTemaInteres] = useState([]);
  const [previewsGaleria, setPreviewsGaleria] = useState([]);

  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (reporteParaEditar) {
      const { data } = reporteParaEditar;
      setTitulo(data.titulo || '');
      setResumen(data.resumen || '');
      setCifraLongitud(data.cifras?.longitud || '');
      setCifraInversion(data.cifras?.inversion || '');
      setCifraDuracion(data.cifras?.duracion || '');
      setCifraTpd(data.cifras?.tpd || '');
      setDescParrafo1(data.descripcion?.parrafo1 || '');
      setDescParrafo2(data.descripcion?.parrafo2 || '');
      setDescParrafo3(data.descripcion?.parrafo3 || '');
      setDescParrafo4(data.descripcion?.parrafo4 || '');
      setCompromisos(data.compromisos?.join('\n') || '');

      setExistingImagenP3Url(data.descripcion?.imagen3_url || null);
      setExistingImagenP4Url(data.descripcion?.imagen4_url || null);
      setExistingTemaInteres(data.tema_interes_urls || []);
      setExistingGaleria(data.galeria_urls || []);
    }
  }, [reporteParaEditar]);

  const handleMarcarParaEliminar = (urlAEliminar) => {
    setUrlsAEliminar(prev => [...prev, urlAEliminar]);
    setExistingTemaInteres(prev => prev.filter(url => url !== urlAEliminar));
    setExistingGaleria(prev => prev.filter(url => url !== urlAEliminar));
    if (existingImagenP3Url === urlAEliminar) setExistingImagenP3Url(null);
    if (existingImagenP4Url === urlAEliminar) setExistingImagenP4Url(null);
  };

  const handleTemaInteresChange = (e) => {
    const files = Array.from(e.target.files);
    setImagenesTemaInteres(files);
    previewsTemaInteres.forEach(url => URL.revokeObjectURL(url));
    const previewUrls = files.map(file => URL.createObjectURL(file));
    setPreviewsTemaInteres(previewUrls);
  };

  const handleRemoveNuevoTemaInteres = (indexToRemove) => {
    URL.revokeObjectURL(previewsTemaInteres[indexToRemove]);
    setImagenesTemaInteres(prev => prev.filter((_, index) => index !== indexToRemove));
    setPreviewsTemaInteres(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleGaleriaChange = (e) => {
    const files = Array.from(e.target.files);
    setImagenesGaleria(files);
    previewsGaleria.forEach(url => URL.revokeObjectURL(url));
    const previewUrls = files.map(file => URL.createObjectURL(file));
    setPreviewsGaleria(previewUrls);
  };

  const handleRemoveNuevaGaleria = (indexToRemove) => {
    URL.revokeObjectURL(previewsGaleria[indexToRemove]);
    setImagenesGaleria(prev => prev.filter((_, index) => index !== indexToRemove));
    setPreviewsGaleria(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  useEffect(() => {
    return () => {
      previewsGaleria.forEach(url => URL.revokeObjectURL(url));
      previewsTemaInteres.forEach(url => URL.revokeObjectURL(url));
    };
  }, [previewsGaleria, previewsTemaInteres]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reporteParaEditar && !imagenPrincipal) {
      setError('Para crear una nueva publicación, la imagen principal es obligatoria.');
      return;
    }
    if (!titulo) {
      setError('El título es obligatorio.');
      return;
    }
    setError('');
    setIsLoading(true);

    const formData = new FormData();
    if (imagenPrincipal) formData.append('imagenPrincipal', imagenPrincipal);
    if (imagenParrafo3) formData.append('imagenParrafo3', imagenParrafo3);
    if (imagenParrafo4) formData.append('imagenParrafo4', imagenParrafo4);
    imagenesTemaInteres.forEach(file => formData.append('imagenesTemaInteres', file));
    imagenesGaleria.forEach(file => formData.append('imagenesGaleria', file));

    const reporteData = {
      titulo, resumen, cifraLongitud, cifraInversion, cifraDuracion,
      cifraTpd, descParrafo1, descParrafo2, descParrafo3, descParrafo4, compromisos,
      urlsAEliminar: urlsAEliminar,
    };
    formData.append('data', JSON.stringify(reporteData));

    const token = localStorage.getItem('token');
    if (!token) {
      setError('No estás autenticado.');
      setIsLoading(false);
      return;
    }

    try {
      const url = reporteParaEditar
        ? `https://api.interventorsisgafr.com/api/reportes/${reporteParaEditar.id}`
        : 'https://api.interventorsisgafr.com/api/reportes';
      const method = reporteParaEditar ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method: method,
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData,
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.msg || 'Error al guardar la publicación.');
      }
      alert(`¡Publicación ${reporteParaEditar ? 'actualizada' : 'creada'} con éxito!`);
      onVolver();
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const API_URL = 'https://api.interventorsisgafr.com/';

  return (
    <div className="interventoria-container">
      <button onClick={onVolver} className="volver-btn">&lt; Volver</button>
      <form onSubmit={handleSubmit} className="editor-section">
        <div className="editor-header">
          <h2>{reporteParaEditar ? 'Editando Publicación' : 'Crear Nueva Publicación'}</h2>
        </div>
        {error && <p className="error-message">{error}</p>}

        <fieldset>
            <legend>Contenido Principal</legend>
            <label>Título del Proyecto*</label>
            <input type="text" value={titulo} onChange={(e) => setTitulo(e.target.value)} required />
            <label>Resumen General (Introducción)</label>
            <textarea rows="4" value={resumen} onChange={(e) => setResumen(e.target.value)}></textarea>
            <label>{reporteParaEditar ? 'Reemplazar Imagen Principal (opcional)' : 'Imagen Principal (para el encabezado)*'}</label>
            <input type="file" onChange={(e) => setImagenPrincipal(e.target.files[0])} accept="image/*" required={!reporteParaEditar} />
        </fieldset>
        
        <fieldset>
            <legend>El Proyecto en Cifras</legend>
            <label>Longitud del Corredor (ej: 137,03 km)</label>
            <input type="text" value={cifraLongitud} onChange={(e) => setCifraLongitud(e.target.value)} />
            <label>Inversión (ej: $1,2 billones)</label>
            <input type="text" value={cifraInversion} onChange={(e) => setCifraInversion(e.target.value)} />
            <label>Duración (ej: 60 meses)</label>
            <input type="text" value={cifraDuracion} onChange={(e) => setCifraDuracion(e.target.value)} />
            <label>Tráfico Promedio (ej: 1.800 vehículos)</label>
            <input type="text" value={cifraTpd} onChange={(e) => setCifraTpd(e.target.value)} />
        </fieldset>

        <fieldset>
            <legend>Descripción del Proyecto y Evidencias</legend>
            <label>Párrafo 1 de Descripción</label>
            <textarea rows="5" value={descParrafo1} onChange={(e) => setDescParrafo1(e.target.value)}></textarea>
            <label>Párrafo 2 de Descripción</label>
            <textarea rows="5" value={descParrafo2} onChange={(e) => setDescParrafo2(e.target.value)}></textarea>
            
            <label>Imagen para Párrafo 3</label>
            {reporteParaEditar && existingImagenP3Url && (
                <div className="galeria-previews-container">
                    <div className="preview-item">
                        <img src={`${API_URL}${existingImagenP3Url}`} alt="Imagen Párrafo 3" className="preview-image"/>
                        <button type="button" className="remove-btn" onClick={() => handleMarcarParaEliminar(existingImagenP3Url)}>&times;</button>
                    </div>
                </div>
            )}
            {!existingImagenP3Url && <input type="file" onChange={(e) => setImagenParrafo3(e.target.files[0])} accept="image/*" />}
            <label>Párrafo 3 de Descripción</label>
            <textarea rows="5" value={descParrafo3} onChange={(e) => setDescParrafo3(e.target.value)}></textarea>
            
            <label>Imagen para Párrafo 4</label>
            {reporteParaEditar && existingImagenP4Url && (
                <div className="galeria-previews-container">
                    <div className="preview-item">
                        <img src={`${API_URL}${existingImagenP4Url}`} alt="Imagen Párrafo 4" className="preview-image"/>
                        <button type="button" className="remove-btn" onClick={() => handleMarcarParaEliminar(existingImagenP4Url)}>&times;</button>
                    </div>
                </div>
            )}
            {!existingImagenP4Url && <input type="file" onChange={(e) => setImagenParrafo4(e.target.files[0])} accept="image/*" />}
            <label>Párrafo 4 de Descripción</label>
            <textarea rows="5" value={descParrafo4} onChange={(e) => setDescParrafo4(e.target.value)}></textarea>
        </fieldset>

        <fieldset>
            <legend>Tema de Interés</legend>
            {reporteParaEditar && existingTemaInteres.length > 0 && (<label>Imágenes Actuales</label>)}
            {reporteParaEditar && existingTemaInteres.length > 0 && (
                <div className="galeria-previews-container">
                    {existingTemaInteres.map((url, index) => (
                        <div key={index} className="preview-item">
                            <img src={`${API_URL}${url}`} alt={`Existente ${index + 1}`} className="preview-image"/>
                            <button type="button" className="remove-btn" onClick={() => handleMarcarParaEliminar(url)}>&times;</button>
                        </div>
                    ))}
                </div>
            )}
            <label>Añadir nuevas imágenes</label>
            <input type="file" multiple onChange={handleTemaInteresChange} accept="image/*" />
            {previewsTemaInteres.length > 0 && (
                <div className="galeria-previews-container">
                    {previewsTemaInteres.map((previewUrl, index) => (
                        <div key={index} className="preview-item">
                            <img src={previewUrl} alt={`Previsualización ${index + 1}`} className="preview-image" />
                            <button type="button" className="remove-btn" onClick={() => handleRemoveNuevoTemaInteres(index)}>&times;</button>
                        </div>
                    ))}
                </div>
            )}
        </fieldset>

        <fieldset>
            <legend>Galería de Imágenes</legend>
            {reporteParaEditar && existingGaleria.length > 0 && (<label>Imágenes Actuales</label>)}
            {reporteParaEditar && existingGaleria.length > 0 && (
                <div className="galeria-previews-container">
                    {existingGaleria.map((url, index) => (
                        <div key={index} className="preview-item">
                            <img src={`${API_URL}${url}`} alt={`Existente ${index + 1}`} className="preview-image"/>
                            <button type="button" className="remove-btn" onClick={() => handleMarcarParaEliminar(url)}>&times;</button>
                        </div>
                    ))}
                </div>
            )}
            <label>Añadir nuevas imágenes</label>
            <input type="file" multiple onChange={handleGaleriaChange} accept="image/*" />
            {previewsGaleria.length > 0 && (
                <div className="galeria-previews-container">
                    {previewsGaleria.map((previewUrl, index) => (
                        <div key={index} className="preview-item">
                            <img src={previewUrl} alt={`Previsualización ${index + 1}`} className="preview-image" />
                            <button type="button" className="remove-btn" onClick={() => handleRemoveNuevaGaleria(index)}>&times;</button>
                        </div>
                    ))}
                </div>
            )}
        </fieldset>

        <fieldset>
            <legend>Nuestro Compromiso</legend>
            <label>Lista de compromisos (uno por línea)</label>
            <textarea rows="6" value={compromisos} onChange={(e) => setCompromisos(e.target.value)} placeholder="Gestión Técnica y Operativa..."></textarea>
        </fieldset>

        <button type="submit" className="submit-reporte" disabled={isLoading}>
            {isLoading ? 'Guardando...' : 'Guardar Publicación'}
        </button>
      </form>
    </div>
  );
};

export default InterventoriaPage;